import {
    Box,
    Button,
    Container,
    Typography
} from "@mui/material";
import React from "react";
import { Reveal } from "../theme/animation";

const TERMS_OF_USE_PDF_URL = "https://docs.google.com/document/d/1sva34NW-8vZ_240H7Uet6MEQOGaHlDx5bKly_8HDp7g/?format=pdf";

const TermsOfUse: React.FC = () => {
    const lastUpdated = "January 2025";

    return (
        <Box>
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <Reveal variant="fadeIn">
                    <Typography variant="h2" component="h1" sx={{
                        textAlign: 'center',
                        mb: 4,
                        fontWeight: 'bold'
                    }}>
                        Platform Terms of Use
                    </Typography>

                    <Typography variant="body2" sx={{
                        textAlign: 'center',
                        mb: 2,
                        color: 'text.secondary',
                        fontStyle: 'italic'
                    }}>
                        Last Updated: {lastUpdated}
                    </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 6 }}>
                        <Button
                            component="a"
                            href={TERMS_OF_USE_PDF_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="outlined"
                            color="primary"
                        >
                            Download Full Terms of Use
                        </Button>
                    </Box>
                </Reveal>
            </Container >
        </Box >
    );
};

export default TermsOfUse;
